import { useEffect } from 'react';

import { clearLocalSession } from '../clearLocalSession';

export const getLastAuthUserKey = () =>
  `CognitoIdentityServiceProvider.${import.meta.env?.VITE_COGNITO_WEB_CLIENT_ID}.LastAuthUser`;

export const useCrossTabSignOut = () => {
  useEffect(() => {
    const onStorage = ({ key }: StorageEvent) => {
      if (key === getLastAuthUserKey()) {
        clearLocalSession();
      }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
};
